(function() {

    const WebFont = require('webfontloader');

    WebFont.load({

        google: {
            families: ['Montserrat:400,500,600,700,800:latin-ext']
        }
    });
})();

